import { parseAsStringLiteral, useQueryState } from 'nuqs';

import AssignmentInfo from './assignment-info';
import AssignmentStatistics from './assignment-statistics';
import { ASSIGNMENT_INFO_VALUES } from './assignment-tabs';

const Assignment = () => {
  const [activeTab] = useQueryState(
    'tab',
    parseAsStringLiteral(ASSIGNMENT_INFO_VALUES).withDefault('info'),
  );

  if (activeTab === 'info') {
    return <AssignmentInfo />;
  }
  if (activeTab === 'statistics') {
    return <AssignmentStatistics />;
  }

  return <></>;
};

export default Assignment;
